var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { createGetComponentFunc, components } from '@appspotr/app';
import { initialState } from './reducer';
var getComponentFunc = createGetComponentFunc(__spreadArray([], (components || []), true));
/**
 * Direct selector to the settings state domain
 */
var selectViewDomain = function (state) { return state.view || initialState; };
var selectApps = function (state) { return (state.root && state.root.apps) || []; };
var selectCurrentApp = function (state) {
    return (state.selectedApp && state.selectedApp) || {};
};
var selectEnv = function (state) {
    return (state.environments && state.environments.environments) || [];
};
export var makeSelectCurrentApp = createSelector(selectCurrentApp, function (currentApp) { return currentApp.app; });
export var makeSelectSavingStatus = createSelector(selectViewDomain, function (view) { return view.saving; });
export var selectCurrentAppStyles = function (state) {
    return (state.viewBuilder && state.viewBuilder.style) || {};
};
export var selectCurrentAppStylesLoading = function (state) {
    return (state.viewBuilder && state.viewBuilder.styles_loading) || false;
};
export var makeSelectView = function (currentViewId) {
    return createSelector(selectViewDomain, selectApps, selectEnv, function (substate, apps, environments) {
        var layout = Object.values(substate.layout);
        var vbLayout = Object.values(substate.vbLayout);
        var padding = substate.padding;
        var defaultGetComponentByName = function () { };
        if (substate.style) {
            defaultGetComponentByName = getComponentFunc(substate.style);
        }
        var selectedComponent = null;
        if (substate.selectedComponentId) {
            selectedComponent = substate.layout[substate.selectedComponentId];
        }
        var configuredStates = substate.states.list.filter(function (state) { return !state.label.startsWith('_'); });
        var loadingStates = [
            {
                name: 'loading',
                type: 'boolean',
                key: 'loading',
                label: 'Loading',
            },
            {
                name: 'loadingText',
                type: 'string',
                key: 'loadingText',
                label: 'Loading Text',
            },
        ];
        var states = __spreadArray(__spreadArray([], configuredStates, true), loadingStates, true);
        var defaultStates = substate.states.defaultStates;
        var bgColor = substate.bgColor;
        if (bgColor === 'unset' && substate.style) {
            bgColor = substate.style.data.backgroundColor;
        }
        var hasExclusiveComponent = layout.some(function (m) {
            return m.properties &&
                m.properties.other &&
                m.properties.other.exclusive &&
                m.properties.other.exclusive.value;
        });
        var filteredViews = (substate.views || []).filter(function (v) { return v.id !== currentViewId; });
        return __assign(__assign({}, substate), { padding: __assign({ top: 0, bottom: 0, left: 0, right: 0 }, padding), 
            // inputs,
            views: filteredViews, layout: layout, vbLayout: vbLayout, selectedComponent: selectedComponent, getComponentByName: defaultGetComponentByName, bgColor: bgColor, hasExclusiveComponent: hasExclusiveComponent, apps: apps, states: states, env: environments, defaultStates: defaultStates });
    });
};
export var selectSelectedTab = function (state) { return state.view.selectedTab || 'default'; };
export var selectComponentProperties = createSelector(selectViewDomain, function (domain) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = domain.selectedComponentId, selectedComponentId = _m === void 0 ? '' : _m, _o = domain.selectedTab, selectedTab = _o === void 0 ? 'default' : _o, _p = domain.layout, layout = _p === void 0 ? {} : _p;
    var properties;
    var logic;
    var component_states = ((_a = layout[selectedComponentId]) === null || _a === void 0 ? void 0 : _a.component_states) || {};
    var formattedLogicArray = [];
    for (var key in component_states) {
        if (((_b = component_states[key]) === null || _b === void 0 ? void 0 : _b.conditions) &&
            ((_d = (_c = component_states[key]) === null || _c === void 0 ? void 0 : _c.conditions) === null || _d === void 0 ? void 0 : _d.formattedLogic)) {
            formattedLogicArray.push({
                key: key,
                formattedLogic: (_f = (_e = component_states[key]) === null || _e === void 0 ? void 0 : _e.conditions) === null || _f === void 0 ? void 0 : _f.formattedLogic,
            });
        }
    }
    if (selectedTab === 'default') {
        properties = ((_g = layout[selectedComponentId]) === null || _g === void 0 ? void 0 : _g.properties) || {};
        logic = {};
    }
    else {
        properties = ((_h = layout[selectedComponentId]) === null || _h === void 0 ? void 0 : _h.component_states[selectedTab].properties)
            ? (_j = layout[selectedComponentId]) === null || _j === void 0 ? void 0 : _j.component_states[selectedTab].properties
            : {};
        logic = ((_k = layout[selectedComponentId]) === null || _k === void 0 ? void 0 : _k.component_states[selectedTab].conditions)
            ? (_l = layout[selectedComponentId]) === null || _l === void 0 ? void 0 : _l.component_states[selectedTab].conditions
            : {};
    }
    return { properties: properties, logic: logic, formattedLogicArray: formattedLogicArray };
});
